import React from 'react';
import cn from 'classnames';
import {createUseStyles} from 'react-jss';

type Props = {
  className?: string
}

/**
 * Skeleton loader
 */
export default function Skeleton({className}: Props) {
  const styles = createUseStyles({
    skeleton: {
      opacity: '0.2',
      backgroundColor: '#d7dce0',
    },
  })();
  return (
    <div className={cn('animate-pulse h-5 rounded', className, styles.skeleton)}/>
  );
}
